<template>
    <ul class="follow-list">
        <li>
        <ShareNetwork
            network="facebook"
            :url="url"
            :title="title"
            :description="description"
            :quote="description"
            hashtags="planetcricket"
            >
            <span class="icon-wrap"><img width="26" height="26" class="lazyload" :src="require('@/assets/images/facebook.png')" alt="Afghanistan" /></span>
            <span class="title">Facebook</span>
        </ShareNetwork>
        </li>
        <li>
        <ShareNetwork
            network="Twitter"
            :url="url"
            :title="title"
            :description="description"
            hashtags="planetcricket"
            >
            <span class="icon-wrap"><img width="26" height="26" class="lazyload" :src="require('@/assets/images/twitter.png')" alt="Afghanistan" /></span>
            <span class="title">Twitter</span>
        </ShareNetwork>
        </li>
        <!--        <li>
                    <a href="#">
                        <span class="icon-wrap"><img width="26" height="26" class="lazyload" :src="require('@/assets/images/instagram.png')" alt="Afghanistan" /></span>
                        <span class="title">Instagram</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <span class="icon-wrap"><img class="lazyload" :src="require('@/assets/images/youtube.png')" alt="Afghanistan" /></span>
                        <span class="title">YouTube</span>
                    </a>
                </li>-->
        <li>
        <ShareNetwork
            network="LinkedIn"
            :url="url"
            :title="title"
            :description="description"
            >
            <span class="icon-wrap"><img width="26" height="26" class="lazyload" :src="require('@/assets/images/linkdin.png')" alt="Afghanistan" /></span>
            <span class="title">LinkedIn</span>
        </ShareNetwork>
        </li>
        <!--        <li>
                    <a href="#">
                        <span class="icon-wrap"><img width="26" height="26" class="lazyload" :src="require('@/assets/images/rss.png')" alt="Afghanistan" /></span>
                        <span class="title">RSS</span>
                    </a>
                </li>-->
    </ul>
</template>

<script>
    import Vue from 'vue';
    import VueSocialSharing from 'vue-social-sharing';
    Vue.use(VueSocialSharing);
    export default {
        name: 'socialMedia',
        data() {
            return {
                url: "",
                title: "",
                description: "",
            }
        },
        mounted() {
            setTimeout(() => {
                this.url = window.location;
                this.title = document.title;
                this.description = $(document.querySelector('meta[description]')).attr('description');

            }, 1000)
        },
    }
</script>

